// extracted by mini-css-extract-plugin
export default {"fast-tracks":"FastTracks_fast-tracks__GzEo5","fast-track-header":"FastTracks_fast-track-header__5NRu6","interactive-tiles":"FastTracks_interactive-tiles__3WCnW"};